import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authPostApi } from "../../services/api";
import { apiEndPoints } from "../../config/path";
import { showError } from "../../helpers/messageHelper";


type ResponseData = {
    subscriptionId?: string;
    shortUrl?: string;
};

type LoginDataState = {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  responseCode: number | null;
  responseData: ResponseData;
  token: string;
};

const initialState: LoginDataState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  responseCode: 0,
  responseData: {},
  token: "",
};

type LoginDataValues = {
  planId: string;
};

export const createSubscriptionData  = createAsyncThunk(
  "/createSubscriptionData",
  async (values: LoginDataValues) => {
    try {
      const valuesData = { ...values };
      const payload = await authPostApi(apiEndPoints.CREATE_SUBSCRIPTION, valuesData);
      console.log("payload:::", payload);
      return payload;
    } catch (e: any) {
      showError(e.response.data.message);
      
    }
  }
);
export const createSubscriptionSlice = createSlice({
  name: "createSubscription",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        .addCase(createSubscriptionData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createSubscriptionData.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.responseCode = payload && payload?.status;
        state.responseData = payload && payload.data.data;
      })
      .addCase(createSubscriptionData.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      })
  },
});

export const createSubscriptionReducer = createSubscriptionSlice.reducer;
